/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import React, { useContext } from 'react';
import Login from "./components/Login"
import Alert from "./components/Alert"
import TotpConfirm from "./components/TotpConfirm";
import TenantList from "./components/TenantList";
import MenuList from "./components/MenuList";
import AccountList from "./components/AccountList";
import Account from "./components/Account";
import ResetPassword from "./components/ResetPassword";
import ResetPasswordGenerateCode from "./components/ResetPasswordGenerateCode";
import ChangeTempPassword from './components/ChangeTempPassword';
import * as CognitoService from "./aws/cognito";
import { IndexContext } from "./IndexProvider";
import PAGES from "./consts/pages";
import LoginAccount from './components/LoginAccount';


export default function App() {
    const { jwtToken, setJwtToken, message, currentPage, setCurrentPage, breadcrumbs, setBreadcrumbs, accountDetails, setAccountDetails, setSelectedAccount, setSelectedTenant, getMfaState, setPageLoading } = useContext(IndexContext);

    const getCurrentPageElement = () => {
        switch (currentPage) {
            case PAGES.LOGIN: return <Login />
            case PAGES.TOTP: return <TotpConfirm />
            case PAGES.MENUS: return <MenuList />
            case PAGES.ORGS: return <TenantList />
            case PAGES.ACCOUNTS: return <AccountList />
            case PAGES.ACCOUNT: return <Account />
            case PAGES.RESET_PASSWORD_GENERATE_CODE: return <ResetPasswordGenerateCode />
            case PAGES.RESET_PASSWORD: return <ResetPassword />
            case PAGES.CHANGE_TEMP_PASSWORD: return <ChangeTempPassword/>
            case PAGES.LOGIN_ACCOUNT: return <LoginAccount/>
            default: return <Login />
        }
    }

    const onBreadcrumbClick = (page, idx, event) => {
        event.preventDefault()
        event.stopPropagation()
        setCurrentPage(page)
        let newBreadcrumbs = breadcrumbs.slice(0, idx + 1)
        setBreadcrumbs(newBreadcrumbs)
    }

    const onTopLinkClick = (e) => {
        e.preventDefault()
        setBreadcrumbs([{ title: "トップ", page: PAGES.MENUS }])
        setCurrentPage(PAGES.MENUS)
    }

    const onLogoutLinkClick = async (e) => {
        e.preventDefault()
        setBreadcrumbs([])
        setCurrentPage(PAGES.LOGIN)
        setJwtToken(undefined)
        setAccountDetails(undefined)
        try {
            await CognitoService.signout()
        } catch (err) { }
    }

    const onAccountLinkClick = async (e) => {
        e.preventDefault()
        const tenant = { tenant_id: accountDetails.tenant_id, tenant_name: accountDetails.tenant_name }
        const account = Object.assign({}, accountDetails)
        setSelectedAccount(account)
        setSelectedTenant(tenant)
        setPageLoading(true)
        setBreadcrumbs([{ title: "トップ", page: PAGES.MENUS }, { title: `アカウント詳細`, path: PAGES.LOGIN_ACCOUNT }])
        setCurrentPage(PAGES.LOGIN_ACCOUNT)
        await getMfaState()
        setPageLoading(false)
    }

    const getBreadcrumbsDisplayClass = () => {
        return currentPage === PAGES.MENUS || currentPage === PAGES.LOGIN || currentPage === PAGES.TOTP || currentPage === PAGES.RESET_PASSWORD_GENERATE_CODE || currentPage === PAGES.CHANGE_TEMP_PASSWORD ? "d-none" : ""
    }

    return (
        <div>
            <div className="d-flex w-100 align-items-center justify-content-between" style={{ height: 60, backgroundColor: "#0073E8" }}>
                <div className="align-items-center ps-2 d-none d-md-flex"><img src="assets/images/pegada_logo.png" height="40" /></div>
                <div></div>
                {
                    accountDetails ?
                        <div className="d-flex align-items-center justify-content-end pe-3" >
                            <a className="white-link me-3" style={{ cursor: "pointer" }} onClick={onTopLinkClick}>トップ</a>
                            <a className="white-link me-3" style={{ cursor: "pointer" }} onClick={onLogoutLinkClick}>ログアウト</a>
                            <a className="white-link" style={{ cursor: "pointer" }} onClick={onAccountLinkClick}>{accountDetails ? accountDetails.account_name : ""}</a>
                        </div>
                        :
                        <div></div>
                }
            </div>
            <div className={"ps-3 pe-3 pt-2 pb-0 " + getBreadcrumbsDisplayClass()} style={{ borderBottom: "1px solid rgb(222, 226, 230)" }} >
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-2">
                        {
                            breadcrumbs.map((bc, idx) => {
                                return (
                                    idx === breadcrumbs.length - 1 ?
                                        <li className="breadcrumb-item active" key={idx} aria-current="page">{bc.title}</li>
                                        :
                                        <li className="breadcrumb-item" key={idx} onClick={(e) => {
                                            onBreadcrumbClick(bc.page, idx, e)
                                        }} aria-current="page">
                                            <a style={{ cursor: "pointer" }}>{bc.title}</a>
                                        </li>
                                )
                            })
                        }
                    </ol>
                </nav>
            </div>
            {getCurrentPageElement()}
            <Alert {...message} />
        </div >
    )
}